import { render, staticRenderFns } from "./commodityAddAttribute.vue?vue&type=template&id=dffdf4e2&scoped=true"
import script from "./commodityAddAttribute.vue?vue&type=script&lang=js"
export * from "./commodityAddAttribute.vue?vue&type=script&lang=js"
import style0 from "./commodityAddAttribute.vue?vue&type=style&index=0&id=dffdf4e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dffdf4e2",
  null
  
)

export default component.exports